import Pagination from 'react-js-pagination';

import DoubleArrowNext from '@/components/Icon/DoubleArrowNext';
import DoubleArrowPrev from '@/components/Icon/DoubleArrowPrev';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';

import * as S from './style';

interface PaginationProps {
	children: React.ReactNode;
	activePage?: number;
	itemsPerPage?: number;
	totalItems?: number;
	onChange?: (pageNumber: number) => void;
}

const TablePagination = ({
	children,
	activePage = 1,
	itemsPerPage = 10,
	totalItems = 450,
	onChange = () => {},
}: PaginationProps) => (
	<S.PaginationContainer>
		{children}
		<Pagination
			activePage={activePage}
			itemsCountPerPage={itemsPerPage}
			totalItemsCount={totalItems}
			pageRangeDisplayed={5}
			onChange={onChange}
			firstPageText={<DoubleArrowPrev width="24" height="24" />}
			lastPageText={<DoubleArrowNext width="24" height="24" />}
			prevPageText={<SingleArrowPrev width="24" height="24" />}
			nextPageText={<SingleArrowNext width="24" height="24" />}
			linkClassFirst="first-page-btn"
			linkClassLast="last-page-btn"
			linkClassPrev="prev-page-btn"
			linkClassNext="next-page-btn"
		/>
	</S.PaginationContainer>
);

export default TablePagination;
